"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var material_ui_1 = require("material-ui");
var Button_1 = __importDefault(require("./Button"));
var utils_1 = require("../../utils");
/**
 * Helper Class Wrapper around button, so Material-UI can use ref on it
 */
var ClassButton = recompose_1.compose(recompose_1.toClass)(Button_1.default);
/**
 * MenuItem wrapper which overrides the onClick handler, sending value instead of event and react child element
 *
 * Used properties: onItemClick used instead of onClick
 */
var ButtonMenuItem = recompose_1.compose(recompose_1.defaultProps({
    onItemClick: utils_1.noop,
}), recompose_1.withHandlers({
    onClick: function (_a) {
        var value = _a.value, onItemClick = _a.onItemClick;
        return function () {
            return onItemClick(value);
        };
    },
}), recompose_1.mapProps(function (_a) {
    var onItemClick = _a.onItemClick, rest = __rest(_a, ["onItemClick"]);
    return (__assign({}, rest));
}))(material_ui_1.MenuItem);
var ButtonMenu = function (_a) {
    var icon = _a.icon, label = _a.label, open = _a.open, handleMenuChange = _a.handleMenuChange, items = _a.items, handleItemClick = _a.handleItemClick, disabled = _a.disabled, props = __rest(_a, ["icon", "label", "open", "handleMenuChange", "items", "handleItemClick", "disabled"]);
    return (react_1.default.createElement(material_ui_1.IconMenu, __assign({ iconButtonElement: react_1.default.createElement(ClassButton, { icon: icon, label: label, disabled: items.length === 0 || disabled }), open: open, onRequestChange: handleMenuChange, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } }, props), items.map(function (item, i) { return (react_1.default.createElement(ButtonMenuItem, { key: i, value: item.value, primaryText: item.text, onItemClick: handleItemClick })); })));
};
/**
 * Button with dropdown menu component
 */
exports.default = recompose_1.compose(recompose_1.defaultProps({
    items: [],
    onItemClick: utils_1.noop,
    labelFunction: utils_1.identity,
    valueFunction: utils_1.identity,
}), recompose_1.withStateHandlers({
    open: false,
}, {
    handleMenuChange: function (state) { return function (open) { return ({ open: open }); }; },
}), recompose_1.withHandlers({
    handleItemClick: function (_a) {
        var handleMenuChange = _a.handleMenuChange, onItemClick = _a.onItemClick;
        return function (childValue) {
            onItemClick(childValue);
            handleMenuChange(false);
        };
    },
}), recompose_1.mapProps(function (_a) {
    var onItemClick = _a.onItemClick, labelFunction = _a.labelFunction, valueFunction = _a.valueFunction, items = _a.items, rest = __rest(_a, ["onItemClick", "labelFunction", "valueFunction", "items"]);
    return (__assign({ items: items
            .map(function (item) { return ({
            text: labelFunction(item),
            value: valueFunction(item),
        }); })
            .sort(function (item1, item2) { return lodash_1.get(item1, 'text', '_undefined').localeCompare(lodash_1.get(item2, 'text', '_undefined')); }) }, rest));
}))(ButtonMenu);
//# sourceMappingURL=ButtonMenu.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/ButtonMenu.js
// module id = 2029
// module chunks = 0